module.exports = __webpack_public_path__ + "img/70_38.cd597161.png";